/**
 * Stride API v2 — base URL from environment only (see `.env.example`).
 *
 * - Dev: `VITE_API_BASE_URL=localhost:3000` in `.env.development` + `API_PROXY_TARGET` in `.env` / `.env.local`
 * - Production build: full `VITE_API_BASE_URL` in `.env` or hosting env vars
 */

function requireEnv(name: 'VITE_API_BASE_URL'): string {
  const value = import.meta.env[name]?.trim()
  if (!value) {
    throw new Error(
      `${name} is not set. Copy .env.example to .env, set your API URL, and restart the dev server.`
    )
  }
  return value
}

export const API_BASE_URL = requireEnv('VITE_API_BASE_URL')
